const UPSTREAM_BRAND = /Chatwoot/g;

const rebrand = (value, name) => {
  if (typeof value === 'string') return value.replace(UPSTREAM_BRAND, name);
  if (Array.isArray(value)) return value.map(item => rebrand(item, name));
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, rebrand(item, name)])
    );
  }
  return value;
};

/**
 * Swaps the upstream product name in every locale message for the
 * installation name, so white-labelled installs never show "Chatwoot".
 * Only the capitalised word is replaced; lowercase URLs and identifiers stay.
 */
export const brandMessages = (
  messages,
  name = window.globalConfig?.INSTALLATION_NAME
) => {
  if (!name || name === 'Chatwoot') return messages;
  return rebrand(messages, name);
};
